import React, { useState, useEffect, useRef } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { makeApiRequest } from '../axiosService/apiCall';
import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';
import config from './config';
import { ToastContainer, toast } from 'react-toastify';
import { CiCircleInfo } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router-dom";

function AdminSettings() {
    const [selectedNetwork, setSelectedNetwork] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [coinaddress, setCoinaddress] = useState('');
    const [coinprivatekey, setCoinprivatekey] = useState('');
    // const [CoinRatio_usdt, setCoinRatioUsdt] = useState("");
    // const [CoinRatio_texa, setCoinRatioTexa] = useState("");
    // const [CommissionFee, setCommissionFee] = useState("");
    const [bnb_coinLimit, setBnbCoinLimit] = useState(0);
    const [bnb_TokenLimit, setBnbTokenLimit] = useState(0);
    // const [texa_gasLimit, setTexaGasLimit] = useState("");
    const [texa_coinLimit, setTexaCoinLimit] = useState(0);
    const navigate = useNavigate();
    const [rewardAmount, setRewardAmount] = useState("");
    const [adminLoading, setAdminLoading] = useState(false);

    const errorRef = useRef(null);
    const [mlmbalance, setMlmbalance] = useState(0);
    const [usdtCount, setUsdtCount] = useState(0);
    const [texaCount, setTexaCount] = useState(0);
    const [countLoading, setCountLoading] = useState(false);
    const [rewardLoading, setRewardLoading] = useState(false);
    const [marketPrice, setMarketPrice] = useState(0);


    useEffect(() => {
        fetchSettings();
        fetchdepositeCount();
        fetchMarketPrice();
    }, []);

    const formik = useFormik({
        initialValues: {
            coinaddress: coinaddress,
            coinprivatekey: coinprivatekey,
            // CoinRatio_usdt: CoinRatio_usdt,
            // CoinRatio_texa: CoinRatio_texa,
            // CommissionFee: CommissionFee,
            bnb_coinLimit: bnb_coinLimit,
            bnb_TokenLimit: bnb_TokenLimit,
            // texa_gasLimit: texa_gasLimit,
            texa_coinLimit: texa_coinLimit,
        },
        validationSchema: yup.object().shape({
            coinaddress: yup
                .string()
                .matches(/^0x[a-fA-F0-9]{40}$/, "Invalid EVM address")
                .required("EVM Address is required"),
            coinprivatekey: yup.string().required("Private Key is required"),
            // CoinRatio_usdt: yup.number().required("USDT Ratio is required"),
            // CoinRatio_texa: yup.number().required("TEXA Ratio is required"),
            // CommissionFee: yup.number().required("Commission Fee is required"),
            bnb_coinLimit: yup.number().required("BNB Coin Limit is required"),
            bnb_TokenLimit: yup.number().required("BNB Token Limit is required"),
            // texa_gasLimit: yup.number().required("TEXA Gas Limit is required"),
            texa_coinLimit: yup.number().required("TEXA Coin Limit is required"),
        }),
        onSubmit: async (values) => {

            try {
                setIsLoading(true);
                let params = {
                    url: `admin-settings`,
                    method: 'POST',
                    data: values
                };

                const response = await makeApiRequest(params);

                if (response.status) {
                    toast.success("Settings updated successfully");
                    fetchSettings();

                } else {
                    toast.error("Error updating settings");
                    fetchSettings();
                }
            } catch (error) {

                toast.error("An unexpected error occurred.");
            } finally {
                setIsLoading(false);
            }
        },
    });

    const fetchMarketPrice = async () => {
        setCountLoading(true);
        try {
            let params = {
                url: `getTexaMarketPrice`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            console.log("fetchMarketPrice--", response);
            if (response.status) {
                setMarketPrice(response.data?.last_price)

            } else {
                setMarketPrice(0);
            }

        } catch (error) {
            console.log('Error fetching deposit count:', error);
        }
    }


    const fetchdepositeCount = async () => {
        setCountLoading(true);
        try {
            let params = {
                url: `getDepositeCount`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            console.log("fetchdepositeCount--", response);
            if (response.status) {
                setCountLoading(false);
                setUsdtCount(response.UsdtDepositeCount);
                setTexaCount(response.TexaDepositeCount);
            } else {
                setCountLoading(false);
                setUsdtCount(0);
                setTexaCount(0);
            }

        } catch (error) {
            console.log('Error fetching deposit count:', error);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (mlmbalance == 0) {
            toast.error("Level Income Reward is 0");
            return;
        }

        const payload = {
            rewardAmount: mlmbalance,
            coinaddress: coinaddress,
        };

        const params = {
            url: "adminlevelincomeclaim",
            method: "POST",
            data: payload,
        };

        try {
            setRewardLoading(true);

            const response = await makeApiRequest(params);
            // console.log('response', response)

            if (response.status === true) {
                toast.success(response.message);
                setRewardLoading(false);
                fetchSettings();
            } else {
                toast.warning(response.message);
                setRewardLoading(false);
                fetchSettings();
            }
        } catch (error) {
            console.error("API Error:", error);
            toast.error("Something went wrong. Please try again.");
            setRewardLoading(false);
        }
    };

    const fetchSettings = async () => {
        try {
            let params = {
                url: `getadminsitesettings`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log("response--", response);

            if (response.status) {
                formik.setValues({
                    coinaddress: response.existsitesetting.coinaddress,
                    coinprivatekey: response.adminEvmPrivateKey,
                    // CoinRatio_usdt: response.existsitesetting.CoinRatio.usdt,
                    // CoinRatio_texa: response.existsitesetting.CoinRatio.texa,
                    // CommissionFee: response.existsitesetting.CommissionFee,
                    bnb_coinLimit: response.existsitesetting.bnb_coinLimit,
                    bnb_TokenLimit: response.existsitesetting.bnb_TokenLimit,
                    // texa_gasLimit: response.existsitesetting.texa_gasLimit,
                    texa_coinLimit: response.existsitesetting.texa_coinLimit,
                });
                setCoinaddress(response.existsitesetting.coinaddress);
                setCoinprivatekey(response.adminEvmPrivateKey);
                // setCoinRatioUsdt(response.existsitesetting.CoinRatio.usdt);
                // setCoinRatioTexa(response.existsitesetting.CoinRatio.texa);
                // setCommissionFee(response.existsitesetting.CommissionFee);
                setBnbCoinLimit(response.existsitesetting.bnb_coinLimit);
                setBnbTokenLimit(response.existsitesetting.bnb_TokenLimit);
                setMlmbalance(response.adminmlmbalance);
                // setTexaGasLimit(response.existsitesetting.texa_gasLimit);
                setTexaCoinLimit(response.existsitesetting.texa_coinLimit);
            }

        } catch (error) {
            console.log('Error fetching settings:', error);
        }
    };

    const moveToAdmin = async (network) => {
        setAdminLoading(true)
        if (!network) {
            setAdminLoading(false)
            toast.error("Please select a network.");
            return;
        }

        try {
            let params = {
                url: "adminMove",
                method: "POST",
                data: { network }
            };

            const response = await makeApiRequest(params);

            if (response.status === true) {
                setAdminLoading(false)
                toast.success(response.message);
                fetchdepositeCount();
            } else {
                setAdminLoading(false)
                toast.error(response.message);
                fetchdepositeCount();
            }
        } catch (error) {
            setAdminLoading(false)
            console.error("Error during moveToAdmin:", error);
        }
    }

    return (
        <div className="row justify-content-center align-items-center mb-5">
            <ToastContainer />
            <div className="col-lg-10">
                <div className="py-3 d-flex justify-content-between">
                    <h3 className="component-user"> Admin Settings</h3>
                </div>
                <div className="site-admin-add-1">
                    <div className='mb-1'>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="d-flex align-items-center">
                                <h5 className="mb-0 me-2">User Deposit Count</h5>
                                {countLoading ? (
                                    <button className='refresh-btn'>
                                        <div class="spinner-border " style={{ width: "20px", height: "20px" }} role="status">
                                            <span class="visually-hidden ">Loading...</span>
                                        </div>
                                    </button>
                                ) : (
                                    <button
                                        className='refresh-btn fw-bold'
                                        onClick={fetchdepositeCount}
                                    >
                                        Refresh
                                    </button>
                                )}
                            </div>
                            {/* <div className="text-end fw-semibold text-primary">
                                <h3 className="component-user">TEXA Price: {marketPrice}</h3>
                            </div> */}
                        </div>
                        <br />

                        <div className="row">
                            <div className="col-md-4">
                                <div className="mb-3 row">
                                    <label htmlFor="Usdt_Count" className="col-sm-6 col-form-label text-end">
                                        USDT Count:
                                    </label>
                                    <div className="col-sm-6">
                                        <input
                                            type="text"
                                            className="form-control custom-input-1"
                                            id="Usdt_Count"
                                            name="Usdt_Count"
                                            value={usdtCount}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="mb-3 row">
                                    <label htmlFor="Texa_Count" className="col-sm-6 col-form-label text-end">
                                        TEXA Count:
                                    </label>
                                    <div className="col-sm-6">
                                        <input
                                            type="text"
                                            className="form-control custom-input-1"
                                            id="Texa_Count"
                                            name="Texa_Count"
                                            value={texaCount}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className='mb-1'>
                        <h5>Move To Admin</h5><br />

                        <div className='d-flex'>
                            <select
                                className="form-select alt-new-form-select form-select-sm"
                                aria-label=".form-select-sm example"
                                value={selectedNetwork}
                                onChange={(e) => setSelectedNetwork(e.target.value)}
                            >
                                <option value="">Select The Network</option>
                                <option value="BNB">BNB (BEP-20)</option>
                                <option value="TEXA">TEXA</option>
                            </select>
                            <br />
                            <div className="text-center ms-4">
                                {adminLoading ? (<Button
                                    type="submit"
                                    className="register-btn-spinner-1"
                                >
                                    Loading</Button>) : (<Button
                                        type="submit"
                                        className="register-btn-spinner-1"
                                        onClick={() => moveToAdmin(selectedNetwork)}
                                    >
                                        Transfer to Admin Wallet
                                    </Button>)}

                            </div>
                        </div>

                        <br />

                        <Form autoComplete="off">
                            <div className="">
                                <div className='d-flex align-items-center'>
                                    <h5>Admin Wallet Control </h5>
                                </div>

                                <div className='mt-3'>
                                    <div className="mb-3 row">
                                        <label htmlFor="coinaddress" className="col-sm-4 col-form-label text-end">EVM Address :</label>
                                        <div className="col-sm-8">
                                            <input
                                                type="text"
                                                className="form-control custom-input-1"
                                                id="coinaddress"
                                                name="coinaddress"
                                                value={formik.values.coinaddress}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.coinaddress && formik.errors.coinaddress && (
                                                <p style={{ color: 'red' }}>{formik.errors.coinaddress}</p>
                                            )}                                       </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label htmlFor="coinprivatekey" className="col-sm-4 col-form-label text-end">EVM PrivateKey :</label>
                                        <div className="col-sm-8">
                                            <input
                                                type="text"
                                                className="form-control custom-input-1"
                                                id="coinprivatekey"
                                                name="coinprivatekey"
                                                value={formik.values.coinprivatekey}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.coinprivatekey && formik.errors.coinprivatekey && (
                                                <p style={{ color: 'red' }}>{formik.errors.coinprivatekey}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div><br />
                    <div className='mb-1'>
                        <Form autoComplete="off">
                            <div className="mb-3">
                                <div className='d-flex align-items-center'>
                                    <h5 className=''>Admin Coin & Token Limit</h5>
                                </div>

                                <div className='mt-3'>
                                    <div className="mb-3 row">
                                        <label htmlFor="bnb_coinLimit" className="col-sm-4 col-form-label text-end">BNB Coin Limit :</label>
                                        <div className="col-sm-2">
                                            <input
                                                type="text"
                                                className="form-control custom-input-1"
                                                id="bnb_coinLimit"
                                                name="bnb_coinLimit"
                                                value={formik.values.bnb_coinLimit}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                onKeyDown={(e) => {
                                                    if (e.key === '-' || e.key === 'e') {
                                                        e.preventDefault(); // Block negative and exponent characters
                                                    }
                                                }}
                                            />
                                            {formik.touched.bnb_coinLimit && formik.errors.bnb_coinLimit && (
                                                <p style={{ color: 'red' }}>{formik.errors.bnb_coinLimit}</p>
                                            )}                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label htmlFor="bnb_TokenLimit" className="col-sm-4 col-form-label text-end">USDT Token Limit :</label>
                                        <div className="col-sm-2">
                                            <input
                                                type="text"
                                                className="form-control custom-input-1"
                                                id="bnb_TokenLimit"
                                                name="bnb_TokenLimit"
                                                value={formik.values.bnb_TokenLimit}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                onKeyDown={(e) => {
                                                    if (e.key === '-' || e.key === 'e') {
                                                        e.preventDefault(); // Block negative and exponent characters
                                                    }
                                                }}
                                            />
                                            {formik.touched.bnb_TokenLimit && formik.errors.bnb_TokenLimit && (
                                                <p style={{ color: 'red' }}>{formik.errors.bnb_TokenLimit}</p>
                                            )}
                                        </div>
                                    </div>
                                    {/* <div className="mb-3 row">
                                        <label htmlFor="texa_gasLimit" className="col-sm-4 col-form-label text-end">TEXA GAS FEE Limit :</label>
                                        <div className="col-sm-2">
                                            <input
                                                type="text"
                                                className="form-control custom-input-1"
                                                id="texa_gasLimit"
                                                name="texa_gasLimit"
                                                value={formik.values.texa_gasLimit}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.texa_gasLimit && formik.errors.texa_gasLimit && (
                                                <p style={{ color: 'red' }}>{formik.errors.texa_gasLimit}</p>
                                            )}                                        </div>
                                    </div> */}
                                    <div className="mb-3 row">
                                        <label htmlFor="texa_coinLimit" className="col-sm-4 col-form-label text-end">Texa Coin Limit :</label>
                                        <div className="col-sm-2">
                                            <input
                                                type="text"
                                                className="form-control custom-input-1"
                                                id="texa_coinLimit"
                                                name="texa_coinLimit"
                                                value={formik.values.texa_coinLimit}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                onKeyDown={(e) => {
                                                    if (e.key === '-' || e.key === 'e') {
                                                        e.preventDefault(); // Block negative and exponent characters
                                                    }
                                                }}
                                            />
                                            {formik.touched.texa_coinLimit && formik.errors.texa_coinLimit && (
                                                <p style={{ color: 'red' }}>{formik.errors.texa_coinLimit}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-4 text-center">
                                {isLoading ? (
                                    <Button className="register-btn-spinner-1" >
                                        <Spinner animation="border" />
                                    </Button>
                                ) : (
                                    <Button
                                        type="submit"
                                        className="register-btn-spinner-1"
                                        onClick={formik.handleSubmit}
                                    >Submit</Button>
                                )}
                            </div>
                        </Form>

                        <div className='mt-4'>
                            <div className='d-flex align-items-center'>
                                <h5 className=''>INR To Texa</h5>
                            </div>
                            <div className='mt-3'>
                                <div className="mb-3 row">
                                    <label htmlFor="CoinRatio_usdt" className="col-sm-4 col-form-label text-end">INR:</label>
                                    <div className="col-sm-2">
                                        <input
                                            type="text"
                                            className="form-control custom-input-1"
                                            id="CoinRatio_usdt"
                                            name="CoinRatio_usdt"
                                            value={1}
                                            disabled
                                        // onChange={formik.handleChange}
                                        // onBlur={formik.handleBlur}
                                        // onKeyDown={(e) => {
                                        //     if (e.key === '-' || e.key === 'e') {
                                        //         e.preventDefault(); // Block negative and exponent characters
                                        //     }
                                        // }}
                                        />
                                        {/* {formik.touched.CoinRatio_usdt && formik.errors.CoinRatio_usdt && (
                                                <p style={{ color: 'red' }}>{formik.errors.CoinRatio_usdt}</p>
                                            )} */}
                                    </div>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <div className="mb-3 row">
                                    <label htmlFor="CoinRatio_texa" className="col-sm-4 col-form-label text-end">TEXA:</label>
                                    <div className="col-sm-2">
                                        <input
                                            type="text"
                                            className="form-control custom-input-1"
                                            id="CoinRatio_texa"
                                            name="CoinRatio_texa"
                                            value={marketPrice}
                                            disabled
                                        // onChange={formik.handleChange}
                                        // onBlur={formik.handleBlur}
                                        />
                                        {/* {formik.touched.CoinRatio_texa && formik.errors.CoinRatio_texa && (
                                                <p style={{ color: 'red' }}>{formik.errors.CoinRatio_texa}</p>
                                            )} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='site-admin-add-1 mt-5'>
                    <h5>Admin Rewards</h5><br />

                    <form onSubmit={handleSubmit}>
                        {/* Admin Address */}
                        <div className="mb-3 row">
                            <label className="col-sm-4 col-form-label text-end">Admin Address:</label>
                            <div className="col-sm-5">
                                <input
                                    type="text"
                                    className="form-control custom-input-1"
                                    value={coinaddress} // Readonly Field
                                    readOnly
                                />
                            </div>
                        </div>

                        {/* Level Income Reward Amount */}
                        <div className="mb-3 row">
                            <label className="col-sm-4 col-form-label text-end">Level Income Reward Amount:</label>
                            <div className="col-sm-5">
                                <input
                                    type="text"
                                    placeholder="Enter The Reward Amount"
                                    className="form-control custom-input-1"
                                    value={mlmbalance}
                                    disabled
                                />
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="text-center">

                            {rewardLoading ? (
                                <Button className="register-btn-spinner-1" >
                                    <Spinner animation="border" />
                                </Button>
                            ) : (
                                <Button
                                    type="submit"
                                    className="register-btn-spinner-1"
                                >Claim</Button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AdminSettings;
